import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.END:
      return {
        ...action.selectedCategory,
      };
    case actions.SET_NAME:
      return {
        ...state,
        value: {
          ...state.value,
          name: action.name,
        },
      };
    case actions.SET_COLOR:
      return {
        ...state,
        value: {
          ...state.value,
          color: action.color,
        },
      };
    case actions.SET_ORDER:
      return {
        ...state,
        value: {
          ...state.value,
          order: action.order,
        },
      };
      case actions.SET_LOG_SPENT_TIME:
      return {
        ...state,
        value: {
          ...state.value,
          logSpentTime: action.value,
        },
      };
      case actions.SET_COMPLEXITY:
      return {
        ...state,
        value: {
          ...state.value,
          complexity: action.complexity,
        },
      };
      case actions.SET_DEPENDENCIES:
        return {
          ...state,
          value: {
            ...state.value,
            dependencies: action.items,
          },
        };
      case actions.SET_FORECAST_PREFIX:
        return {
          ...state,
          value: {
            ...state.value,
            forecastPrefix: action.value,
          },
        };
    case actions.SET_REMOVED:
      return {
        ...state,
        value: {
          ...state.value,
          isRemoved: action.value,
        },
      };
    case actions.SET_ITEMS:
      return {
        ...state,
        value: {
          ...state.value,
          items: action.items,
        },
      };
      case actions.SET_ROLES:
      return {
        ...state,
        value: {
          ...state.value,
          roles: action.roles,
        },
      };
      case actions.SET_ROLES_SECONDARY:
      return {
        ...state,
        value: {
          ...state.value,
          secondaryRoles: action.roles,
        },
      };
    case actions.INVALIDATE_CHANGES:
      return {
        ...state,
        changes: action.changes,
      };
    case actions.RESET_CHANGES.END:
      return {
        ...state,
        changes: 0,
        value: action.value,
      };
    case actions.CHECK_VALIDATION.END:
      return {
        ...state,
        errors: action.errors
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/category/currentCategory/reducer.js